/**
 * BaseSkeleton - Core skeleton building blocks
 * Base placeholder components for loading states.
 */
import React from 'react';

export function Skeleton({
  className,
  variant = "default",
  delay = false,
  ...props
}) {
  return (
    <div
      className={`${delay ? 'animate-pulse-delayed' : 'animate-pulse'} rounded ${variant === "primary" ? "bg-primary-200 dark:bg-primary-800" : "bg-gray-200 dark:bg-gray-800"} ${className}`}
      style={delay ? { animationDelay: `${Math.random() * 300}ms` } : {}}
      {...props}
    />
  );
}

export function MetricCardSkeleton({ variant = "default" }) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] sm:p-6">
      <div className="space-y-1">
        <Skeleton variant={variant} className="h-4 w-32 mb-2" />
        <div className="flex items-center justify-between">
          <Skeleton variant={variant} className="h-8 w-16 sm:h-10" />
          <div className="rounded-md bg-gray-100/80 p-2 dark:bg-gray-800">
            <Skeleton variant={variant} className="h-5 w-5 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function ChartSkeleton({ height = 300 }) {
  return (
    <div 
      className="w-full rounded-lg border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900/50"
      style={{ height: `${height}px` }}
    >
      <div className="flex h-full w-full flex-col items-center justify-center p-6">
        <Skeleton className="h-full w-full rounded-md opacity-50" />
      </div>
    </div>
  );
}

